

// -------- Development extension index ---------
//      ! THIS FILE WAS AUTO-GENERATED !
//
// You can overwrite it and have fun, to restore
// the default state: 'npm run compile'

import IndicatorSettings from '../../src/extensions/settings-win/IndicatorSettings.vue'
import Main from '../../src/extensions/settings-win/main.js'
Main.__name__ = 'settings-win'

const widgets = { IndicatorSettings }
const components = {  }
const overlays = {  }
const colorpacks = {  }
const skins = {  }

const Pack = {
    widgets,
    IndicatorSettings,
    components,
    overlays,
    colorpacks,
    skins,
    Main
}

export default Pack

export {
    widgets,
    IndicatorSettings,
    components,
    overlays,
    colorpacks,
    skins,
    Main
}